// If you add a new environment variable, make sure to allowlist it in
// the file .platform/hooks/predeploy/01_create_envfile.sh
export enum EnvVariable {
  API_PATHNAME = 'API_PATHNAME',
  ENVIRONMENT = 'ENVIRONMENT',
  ETHENA_SURVICATE_KEY = 'ETHENA_SURVICATE_KEY',
  LIFE_LABS_SURVICATE_KEY = 'LIFE_LABS_SURVICATE_KEY',
  PROTOCOL = 'PROTOCOL',
  SENTRY_DSN = 'SENTRY_DSN',
  ZOOM_COMPANY_ID = 'ZOOM_COMPANY_ID',

  // computed or set by the build process
  NEXT_RUNTIME = 'NEXT_RUNTIME',
  NPM_PACKAGE_VERSION = 'NPM_PACKAGE_VERSION',
  RELEASE = 'RELEASE',
}

export const getEnv = (key: EnvVariable): string => {
  switch (key) {
    case EnvVariable.RELEASE:
      return process.env.RELEASE;
    case EnvVariable.NPM_PACKAGE_VERSION:
      return process.env.NPM_PACKAGE_VERSION;
    case EnvVariable.NEXT_RUNTIME:
      return process.env.NEXT_RUNTIME;
    default:
      if (typeof window === 'undefined') {
        return process.env[key];
      } else {
        return window.env[key];
      }
  }
};

export const getIsSecureEnvironment = (): boolean => {
  return getEnv(EnvVariable.PROTOCOL) === 'https://';
};

export const getIsProduction = (): boolean => {
  return getEnv(EnvVariable.ENVIRONMENT) === 'production';
};
